import React from 'react';
import './orderAnalytics.css';
import { 
  LineChart, Line, BarChart, Bar, 
  XAxis, YAxis, CartesianGrid, Tooltip, 
  Legend, ResponsiveContainer, PieChart, 
  Pie, Cell 
} from 'recharts';

const OrderAnalytics = () => {
  // Sample data for charts
  const monthlyData = [
    { name: 'Jan', orders: 45, revenue: 125000 },
    { name: 'Feb', orders: 52, revenue: 142000 },
    { name: 'Mar', orders: 48, revenue: 135000 },
    { name: 'Apr', orders: 60, revenue: 168000 },
    { name: 'May', orders: 72, revenue: 205000 },
    { name: 'Jun', orders: 65, revenue: 185000 },
  ];

  const statusData = [
    { name: 'Completed', value: 78 },
    { name: 'Processing', value: 12 },
    { name: 'Pending', value: 7 },
    { name: 'Cancelled', value: 3 },
  ];

  const topModels = [
    { name: 'Toyota Camry', orders: 32 },
    { name: 'Honda Accord', orders: 28 },
    { name: 'Ford Mustang', orders: 18 },
    { name: 'Tesla Model 3', orders: 15 },
    { name: 'BMW 3 Series', orders: 12 },
  ];

  const COLORS = ['#d10000', '#333', '#888', '#ccc'];

  return (
    <div className="order-analytics">
      <h2>Order Analytics</h2>
      
      <div className="date-range-selector">
        <div className="date-range">
          <label>Date Range:</label>
          <select defaultValue="last6months">
            <option value="lastmonth">Last Month</option>
            <option value="last3months">Last 3 Months</option>
            <option value="last6months">Last 6 Months</option>
            <option value="lastyear">Last Year</option>
            <option value="custom">Custom Range</option>
          </select>
        </div>
        <button className="refresh-btn">Refresh Data</button>
      </div>
      
      <div className="analytics-grid">
        {/* Orders & Revenue Trend */}
        <div className="chart-container trend-chart">
          <h3>Orders & Revenue Trend</h3>
          <div className="chart-wrapper">
            <ResponsiveContainer width="100%" height={300}>
              <LineChart data={monthlyData}>
                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                <XAxis dataKey="name" />
                <YAxis yAxisId="left" orientation="left" />
                <YAxis yAxisId="right" orientation="right" />
                <Tooltip />
                <Legend />
                <Line 
                  yAxisId="left" 
                  type="monotone" 
                  dataKey="orders" 
                  name="Orders" 
                  stroke="#d10000" 
                  strokeWidth={2}
                  activeDot={{ r: 8 }}
                />
                <Line 
                  yAxisId="right" 
                  type="monotone" 
                  dataKey="revenue" 
                  name="Revenue ($)" 
                  stroke="#333" 
                  strokeWidth={2}
                />
              </LineChart>
            </ResponsiveContainer>
          </div>
        </div>
        
        {/* Order Status Distribution */}
        <div className="chart-container status-chart">
          <h3>Order Status Distribution</h3>
          <div className="chart-wrapper">
            <ResponsiveContainer width="100%" height={300}>
              <PieChart>
                <Pie
                  data={statusData}
                  cx="50%"
                  cy="50%"
                  labelLine={false}
                  outerRadius={80}
                  fill="#8884d8"
                  dataKey="value"
                  nameKey="name"
                  label={({ name, percent }) => `${name}: ${(percent * 100).toFixed(0)}%`}
                >
                  {statusData.map((entry, index) => (
                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                  ))}
                </Pie>
                <Tooltip />
                <Legend />
              </PieChart>
            </ResponsiveContainer>
          </div>
        </div>
        
        {/* Top Car Models */}
        <div className="chart-container models-chart">
          <h3>Top Car Models by Orders</h3>
          <div className="chart-wrapper">
            <ResponsiveContainer width="100%" height={300}>
              <BarChart data={topModels}>
                <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                <XAxis dataKey="name" />
                <YAxis />
                <Tooltip />
                <Legend />
                <Bar 
                  dataKey="orders" 
                  name="Number of Orders" 
                  fill="#d10000" 
                  radius={[4, 4, 0, 0]}
                />
              </BarChart>
            </ResponsiveContainer>
          </div>
        </div>
        
        {/* Key Metrics */}
        <div className="metrics-container">
          <h3>Key Metrics</h3>
          <div className="metrics-grid">
            <div className="metric-card">
              <div className="metric-value">342</div>
              <div className="metric-label">Total Orders</div>
            </div>
            <div className="metric-card">
              <div className="metric-value">$1,240,500</div>
              <div className="metric-label">Total Revenue</div>
            </div>
            <div className="metric-card">
              <div className="metric-value">$3,627</div>
              <div className="metric-label">Avg. Order Value</div>
            </div>
            <div className="metric-card">
              <div className="metric-value">86%</div>
              <div className="metric-label">Completion Rate</div>
            </div>
          </div>
        </div>
      </div>
      
      <div className="export-section">
        <button className="export-btn">Export Analytics Report</button>
        <button className="print-btn">Print Dashboard</button>
      </div>
    </div>
  );
};

export default OrderAnalytics;